import AuthProfileList from '@/components/Auth/Profiles/AuthProfileList'
import { ColorEnum } from '@/constants/color'
import CurrentProfileCard from '@/features/auth/components/CurrentProfileCard'
import ProfileActiveSessionLogoutAction from '@/features/auth/components/ProfileActiveSessionLogoutAction'
import TitleWithHint from '@/features/auth/components/TitleWithHint'
import { useAppSelector } from '@/hooks/redux'
import { useScreenLayout } from '@/hooks/screen'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { Redirect, useRouter } from 'expo-router'
import { FC, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const ProfileActiveSessionPage: FC = () => {
    const profile = useAppSelector(authSelectors.currentProfile)
    const profiles = useAppSelector(authSelectors.profiles)

    const router = useRouter()

    const screenLayout = useScreenLayout()

    const { t } = useTranslation()

    const activeProfileUuidRef = useRef(profile?.uuid)

    if (!profile || !profiles) {
        return <Redirect href="/auth/profiles" />
    }

    if (profile.uuid !== activeProfileUuidRef.current) {
        return <Redirect href="/auth/profile-pin" />
    }

    if (screenLayout === 'compact') {
        return <Redirect href="/orders" />
    }

    const handleCurrentProfileCardPress = () => {
        router.replace('/orders')
    }

    const otherProfiles = profiles.filter(({ uuid }) => uuid !== profile.uuid)

    return (
        <View style={styles.container}>
            <TitleWithHint
                title={t('profileScreensLogin')}
                hint={t('auth.profileActiveSessionScreenChoice')}
            />
            <CurrentProfileCard
                name={profile.name}
                description={profile.description ?? undefined}
                onPress={handleCurrentProfileCardPress}
                RightContent={<ProfileActiveSessionLogoutAction />}
            />
            <AuthProfileList profiles={otherProfiles} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.JET_800,
        overflow: 'hidden',
    },
})

export default ProfileActiveSessionPage
